"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetStatsWithDependenciesSerializedSchema = exports.NetStatsDependencySchema = void 0;
const zod_1 = require("zod");
const IModeDependency_1 = require("./IModeDependency");
const INetStats_1 = require("./INetStats");
const ISerializedCircuitState_1 = require("./ISerializedCircuitState");
exports.NetStatsDependencySchema = zod_1.default.discriminatedUnion('type', [
    IModeDependency_1.IModeDependencySchema,
    IModeDependency_1.INetStateDependencySchema,
]);
exports.NetStatsWithDependenciesSerializedSchema = zod_1.default.object({
    dependencies: exports.NetStatsDependencySchema.array(),
    resolvesModeStates: IModeDependency_1.IModeDependencySchema.array(),
    netStats: zod_1.default.record(zod_1.default.string(), INetStats_1.INetStatsSchema),
    circuitStates: zod_1.default.record(zod_1.default.string(), ISerializedCircuitState_1.ISerializedCircuitStateSchema).optional(),
});
//# sourceMappingURL=NetStatsWithDependenciesSerialized.js.map